import { getTenantIdLS, getAccessTokenLS } from 'src/utils/localStorageUtils';

import { API_URL } from 'src/config';

/** Auth headers for AI Settings routes (TTS / STT). */
export function buildAiSettingsAuthHeaders(includeJsonContentType = true): Headers {
  const headers = new Headers();
  if (includeJsonContentType) {
    headers.set('Content-Type', 'application/json');
  }

  const accessToken = getAccessTokenLS();
  const tenantId = getTenantIdLS();

  if (accessToken) {
    headers.set('Authorization', accessToken);
  }
  if (tenantId) {
    headers.set('tenantId', tenantId.toString());
    headers.set('x-tenant-id', tenantId.toString());
  }

  return headers;
}

export function getAiSettingsApiUrl(path: string): string {
  const base = API_URL ?? '';
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return `${base}${normalizedPath}`;
}

export function unwrapApiData<T extends Record<string, unknown>>(json: Record<string, unknown>): T {
  const outer = json.data;
  if (outer && typeof outer === 'object') {
    const nested = (outer as Record<string, unknown>).data;
    if (nested && typeof nested === 'object') {
      return nested as T;
    }
    return outer as T;
  }
  return json as T;
}
